module.exports = __webpack_public_path__ + "static/media/packages.2bcf74dc.svg";